import ErrorBoundary from '@components/ErrorBoundary';
import PageContainer from '@components/PageContainer';
import { OverallAnalysis, OverallAnalysisNotFound } from '@components/common/OverallAnalysis';
import NoAnalysis from '@components/dynamic-survey/details/NoAnalysis';
import Spinner from '@components/spinner/Spinner';
import { useSurveyOverallAnalysis } from '@hooks/getQueries';
import { Box } from '@mui/material';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

const OverallAnalysisContainer = () => {
  const { id } = useParams();
  const { data } = useSurveyOverallAnalysis({ surveyId: id });

  return (
    <Box sx={{ padding: '10px', my: '20px', width: '688px', mx: 'auto' }}>
      {data?.overall_analysis ? (
        <OverallAnalysis data={data?.overall_analysis?.report_response} />
      ) : (
        <OverallAnalysisNotFound text="Survey" />
      )}
    </Box>
  );
};

export default function SurveyOverallAnalysis() {
  const { id } = useParams();

  return (
    <PageContainer title={'Survey | Overall Analysis'} description={'Survey'}>
      <Suspense fallback={<Spinner />}>
        <ErrorBoundary FallbackComponent={() => <NoAnalysis studyId={id} />}>
          <Suspense fallback={<Spinner />}>
            <OverallAnalysisContainer />
          </Suspense>
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
